<template>
  <div v-if="profile != null" id="show-profile">
    <v-row>
      <v-col cols="6">
        <v-card>
          <v-card-title
            >Détails du profile
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              icon
              @click.stop="editProfileDialog = true"
              small
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <edit-profile-dialog
              :profile="profile"
              :open.sync="editProfileDialog"
              v-if="editProfileDialog"
            />
          </v-card-title>
          <v-card-text>
            <div>
              <span class="font-weight-bold"> Libellé :</span>
              {{ profile.label }}
              <v-divider></v-divider>
            </div>
            <div>
              <span class="font-weight-bold"> Description :</span>
              {{ profile.description }}
              <v-divider></v-divider>
            </div>
            <div>
              <span class="font-weight-bold"> Créé par :</span>
              {{ profile.createdBy }}
              <v-divider></v-divider>
            </div>
            <div>
              <span class="font-weight-bold"> Créé à :</span>
              {{ getInternationalDate(profile.createdAt) }}
              <v-divider></v-divider>
            </div>
            <div>
              <span class="font-weight-bold"> Maj par :</span>
              {{ profile.updateddBy }}
              <v-divider></v-divider>
            </div>
            <div>
              <span class="font-weight-bold"> Maj à :</span>
              {{ getInternationalDate(profile.updatedAt) }}
              <v-divider></v-divider>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card>
          <v-card-title>Attributs </v-card-title>
          <v-card-text>
            <v-data-table
              v-if="
                profile != null &&
                profile.attributes != null &&
                profile.attributes.length > 0
              "
              :headers="headers"
              :items="profile.attributes"
              hide-default-footer
            >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>Clients avec ce profil</v-card-title>
          <v-card-text>
            <div id="table-profiles-portails-container">
              <client-portal-datatable
                :filter-params="criteriaClientPortal"
                v-on:fetch-records="$emit('fetch-records', $event)"
              ></client-portal-datatable>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { onMounted, toRefs, watch } from "@vue/composition-api";
import { useTitle } from "@/composables/title";
import router from "@/router";
import { useProfile } from "@/composables/profile";
import { date } from "@/composables/date";
import ClientPortalDatatable from "../components/ClientPortal/ClientPortalDatatable";
import { useClientPortal } from "../composables/client-portal";
import EditProfileDialog from "../components/Profile/EditProfileDialog";
export default {
  components: { EditProfileDialog, ClientPortalDatatable },
  setup() {
    const { setTitle } = useTitle();
    const { showProfile, profile, profileData } = useProfile();

    const profileId = router.currentRoute.params.id;
    const { getInternationalDate } = date();

    onMounted(async () => {
      await showProfile(profileId);
      setTitle("Profile - " + profile.value.label);
    });

    const { criteriaClientPortal } = useClientPortal();

    criteriaClientPortal.value.profile = profileId;

    watch(
      () => profileData.editProfileDialog,
      async (newValue, oldValue) => {
        if (oldValue != null && oldValue != newValue && newValue == false) {
          await showProfile(profileId);
          setTitle("Profile - " + profile.value.label);
        }
      }
    );

    return {
      ...toRefs(profileData),
      profile,
      getInternationalDate,
      criteriaClientPortal,
      headers: [
        { text: "Libellé", value: "name" },
        { text: "Description", value: "value" },
      ],
    };
  },
};
</script>
